<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h1>Stepper</h1>
    <h4>
      <a
        href="https://material.angular.io/components/stepper/examples"
        title="Material Stepper"
        target="_blank"
        >Doc</a
      >
    </h4>

    <div>
      <mat-horizontal-stepper linear>
        <mat-step>
          <ng-template matStepLabel>First</ng-template>
          <p>1</p>
        </mat-step>
        <mat-step>
          <ng-template matStepLabel>Second</ng-template>
          <p>2</p>
        </mat-step>
        <mat-step>
          <ng-template matStepLabel>Done</ng-template>
          <p>3</p>
        </mat-step>
      </mat-horizontal-stepper>
    </div>
  </div>

  <div class="col-12 mb-5 col-sm-6">
    <h1>Tabs</h1>
    <h4>
      <a
        href="https://material.angular.io/components/tabs/examples"
        title="Material Tabs"
        target="_blank"
        >Doc</a
      >
    </h4>

    <div>
      <mat-tab-group mat-align-tabs="start">
        <mat-tab label="First">
          <p>Content 1</p>
        </mat-tab>
        <mat-tab label="Second">
          <p>Content 2</p>
        </mat-tab>
        <mat-tab label="Third">
          <p>Content 3</p>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
